webpackJsonp([1,2],{

/***/ "4k8/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _preact = __webpack_require__("rMlB");

var _htmlDecode = __webpack_require__("tSfd");

var _htmlDecode2 = _interopRequireDefault(_htmlDecode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @summary Slider thumbnail item preact component.
 *
 * @class
 * @extends {Component}
 */
/**
 * @summary Slider thumbnail item preact component.
 */

var SliderThumbsThumb = function (_Component) {
	(0, _inherits3.default)(SliderThumbsThumb, _Component);

	function SliderThumbsThumb(props) {
		(0, _classCallCheck3.default)(this, SliderThumbsThumb);

		var _this = (0, _possibleConstructorReturn3.default)(this, _Component.call(this, props));

		_this.handleClick = _this.handleClick.bind(_this);
		_this.setRef = _this.setRef.bind(_this);
		return _this;
	}

	/**
  * @summary Returns classes for this element.
  *
  * @returns {string} The HTML class attribute string value.
  */


	SliderThumbsThumb.prototype.classes = function classes() {
		var additionalClasses = this.props.classes ? ' ' + this.props.classes : '';
		var activeClass = this.props.active ? ' is-active' : '';

		return 'woocommerce-loop-product' + activeClass + additionalClasses;
	};

	/**
  * @summary Handles a click on the thumbnail element.
  *
  * @listens document:click
  *
  * @param {MouseEvent} event The click event.
  */


	SliderThumbsThumb.prototype.handleClick = function handleClick(event) {
		event.preventDefault();

		if (typeof this.props.handleClick === 'function') {
			this.props.handleClick(this.props.index);
		}
	};

	/**
  * @summary Set reference for the button DOM element of this component.
  *
  * @param {HTMLElement} element The button DOM element.
  */


	SliderThumbsThumb.prototype.setRef = function setRef(element) {
		if (typeof this.props.onRef === 'function') {
			this.props.onRef(element, this.props.index);
		}
	};

	SliderThumbsThumb.prototype.render = function render(_ref) {
		var title = _ref.title,
		    thumb = _ref.thumb;

		thumb.class += ' woocommerce-loop-product__thumbnail';

		return (0, _preact.h)(
			'li',
			null,
			(0, _preact.h)(
				'button',
				{ 'class': this.classes(), onClick: this.handleClick, ref: this.setRef },
				(0, _preact.h)(
					'div',
					{ 'class': 'woocommerce-loop-product__thumbnail-wrapper' },
					(0, _preact.h)('img', thumb)
				),
				(0, _preact.h)(
					'h2',
					{ 'class': 'woocommerce-loop-product__title' },
					(0, _htmlDecode2.default)(title)
				)
			)
		);
	};

	return SliderThumbsThumb;
}(_preact.Component);

exports.default = SliderThumbsThumb;

/***/ }),

/***/ "6LoX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _preact = __webpack_require__("rMlB");

var _debounce = __webpack_require__("O4Lo");

var _debounce2 = _interopRequireDefault(_debounce);

var _SliderMain = __webpack_require__("aW1n");

var _SliderMain2 = _interopRequireDefault(_SliderMain);

var _SliderThumbs = __webpack_require__("tA1e");

var _SliderThumbs2 = _interopRequireDefault(_SliderThumbs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @summary Slider preact preact component.
 *
 * @class
 * @extends {Component}
 */
/**
 * @summary Contains the slider preact component.
 */

var Slider = function (_Component) {
	(0, _inherits3.default)(Slider, _Component);

	function Slider(props) {
		(0, _classCallCheck3.default)(this, Slider);

		var _this = (0, _possibleConstructorReturn3.default)(this, _Component.call(this, props));

		_this.state = {
			activeIndex: 0
		};

		_this.initialLoad = true;
		_this.autoScrolled = false;

		_this.handleThumbnailClick = _this.handleThumbnailClick.bind(_this);
		_this.handleButtonClick = _this.handleButtonClick.bind(_this);
		_this.setMainRef = _this.setMainRef.bind(_this);

		// React to autscrolling from thumbnail click
		_this.autoscrollFocus = (0, _debounce2.default)(_this.autoscrollFocus.bind(_this), 200);
		return _this;
	}

	Slider.prototype.componentDidMount = function componentDidMount() {
		window.addEventListener('scroll', this.autoscrollFocus);
	};

	Slider.prototype.componentWillUnmount = function componentWillUnmount() {
		window.removeEventListener('scroll', this.autoscrollFocus);
	};

	/**
  * @summary Focuses on main element.
  */


	Slider.prototype.autoscrollFocus = function autoscrollFocus() {
		if (this.autoScrolled) {
			this.mainElement.focus();
			this.autoScrolled = false;
		}
	};

	/**
  * @summary Handles a thumbnail click.
  *
  * @listens document:click
  *
  * @param {number} index The index number of the slide to make active.
  */


	Slider.prototype.handleThumbnailClick = function handleThumbnailClick(index) {
		this.setState({
			activeIndex: index
		});

		this.autoScrolled = true;
		this.mainElement.scrollIntoView({
			behavior: 'smooth',
			block: 'start',
			inline: 'nearest'
		});
	};

	/**
  * @summary Handles a navigation button click.
  *
  * @listens document:click
  *
  * @param {('left'|'right')} direction The direction to page once.
  */


	Slider.prototype.handleButtonClick = function handleButtonClick(direction) {
		var _this2 = this;

		this.setState(function (_ref) {
			var activeIndex = _ref.activeIndex;

			var endIndex = _this2.props.data.length - 1;

			// Cases for looping to the other end of the list
			if (direction === 'right' && activeIndex === endIndex) {
				return { activeIndex: 0 };
			} else if (direction === 'left' && activeIndex === 0) {
				return { activeIndex: endIndex };
			}

			return { activeIndex: activeIndex + (direction === 'right' ? 1 : -1) };
		});
	};

	/**
  * @summary Sets a reference to the main slider pane.
  *
  * @param {HTMLElement} element The main slider window element.
  */


	Slider.prototype.setMainRef = function setMainRef(element) {
		this.mainElement = element;
	};

	Slider.prototype.render = function render(_ref2, _ref3) {
		var data = _ref2.data;
		var activeIndex = _ref3.activeIndex;

		if (this.initialLoad) {
			this.initialLoad = false;
		}

		return (0, _preact.h)(
			'div',
			null,
			(0, _preact.h)(_SliderMain2.default, {
				data: data,
				activeIndex: activeIndex,
				setRef: this.setMainRef,
				handleButtonClick: this.handleButtonClick
			}),
			(0, _preact.h)(
				'div',
				{ 'class': 'c-slider__divider u-mb-40 u-mt-30' },
				(0, _preact.h)('div', { 'class': 'c-slider__arrow c-slider__arrow' })
			),
			(0, _preact.h)(_SliderThumbs2.default, {
				data: data,
				activeIndex: activeIndex,
				handleClick: this.handleThumbnailClick
			})
		);
	};

	return Slider;
}(_preact.Component);

exports.default = Slider;

/***/ }),

/***/ "9bBU":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("mClu");
var $Object = __webpack_require__("FeBl").Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),

/***/ "C4MV":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("9bBU"), __esModule: true };

/***/ }),

/***/ "DJyI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__("woOf");

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _preact = __webpack_require__("rMlB");

var _icon = __webpack_require__("erO0");

var _icon2 = _interopRequireDefault(_icon);

var _htmlDecode = __webpack_require__("tSfd");

var _htmlDecode2 = _interopRequireDefault(_htmlDecode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var $ = jQuery;

/**
 * @summary Slider slide preact component.
 *
 * @class
 * @extends {Component}
 */
/**
 * @summary Contains the slider slide preact component
 */

/* globals loweL18n */

var SliderSlide = function (_Component) {
	(0, _inherits3.default)(SliderSlide, _Component);

	function SliderSlide(props) {
		(0, _classCallCheck3.default)(this, SliderSlide);

		var _this = (0, _possibleConstructorReturn3.default)(this, _Component.call(this, props));

		_this.imageAttributes = props.slide;
		_this.imageAttributes.class = 'c-slide__image';

		// Split out image attributes to lazy-load the image on first shown
		_this.imageLoadAttributes = {};
		['src', 'srcset'].forEach(function (name) {
			_this.imageLoadAttributes[name] = _this.imageAttributes[name];
			delete _this.imageAttributes[name];
		});

		_this.setRef = _this.setRef.bind(_this);
		return _this;
	}

	SliderSlide.prototype.componentDidMount = function componentDidMount() {
		var _this2 = this;

		$().ready(function () {
			$(_this2.slide).wc_product_gallery();
		});
	};

	/**
  * @summary Generates an image loading placeholder.
  *
  * Sets the height of the area that the image will take up before it is
  * loaded to pevent content jumps.
  *
  * @return {JSX} The placeholder div element.
  */


	SliderSlide.prototype.imageLoadingPlaceholder = function imageLoadingPlaceholder() {
		var imageSizeRatio = this.imageAttributes.height / this.imageAttributes.width;
		var style = {
			paddingTop: imageSizeRatio * 100 + '%'
		};

		return (0, _preact.h)('div', {
			'class': 'c-slide__load-scaffold',
			'aria-hidden': 'true',
			style: style
		});
	};

	SliderSlide.prototype.setRef = function setRef(element) {
		this.slide = element;
	};

	/**
  * @summary Gets HTML classes for this slide.
  *
  * @returns {string} The HTML class attribute string value.
  */


	SliderSlide.prototype.classes = function classes() {
		var stateClass = '';

		if (this.props.state > 0) {
			stateClass = ' is-inactive-right';
		} else if (this.props.state < 0) {
			stateClass = ' is-inactive-left';
		}
		return 'c-slider__main-item ' + stateClass;
	};

	SliderSlide.prototype.imageGalleryAttributes = function imageGalleryAttributes() {
		return {
			style: 'display:none',
			'data-large_image': this.props.photoswipeData[0],
			'data-large_image_height': this.props.photoswipeData[2],
			'data-large_image_width': this.props.photoswipeData[1],
			'data-src': this.props.photoswipeData[0]
		};
	};

	SliderSlide.prototype.render = function render(_ref) {
		var excerpt = _ref.excerpt,
		    link = _ref.link,
		    title = _ref.title,
		    state = _ref.state,
		    photoswipeData = _ref.photoswipeData;

		if (state === 0 && !('src' in this.imageAttributes)) {
			this.imageAttributes = (0, _assign2.default)({}, this.imageAttributes, this.imageLoadAttributes);
		}

		return (0, _preact.h)(
			'div',
			{ 'class': this.classes() },
			(0, _preact.h)(
				'figure',
				{ 'class': 'c-slide', ref: this.setRef },
				(0, _preact.h)(
					'a',
					{ href: link, title: loweL18n.viewLinkTitle },
					this.imageLoadingPlaceholder(),
					(0, _preact.h)('img', this.imageAttributes)
				),
				(0, _preact.h)(
					'figcaption',
					{ 'class': 'c-slide__caption' },
					(0, _preact.h)(
						'h3',
						{ 'class': 'c-slide__title' },
						(0, _htmlDecode2.default)(title)
					),
					(0, _preact.h)(
						'div',
						{ 'class': 'c-slide__icons' },
						photoswipeData && (0, _preact.h)(
							'div',
							{ 'class': 'woocommerce-product-gallery__image' },
							(0, _preact.h)('img', this.imageGalleryAttributes()),
							(0, _preact.h)(
								'a',
								{ href: '#', 'class': 'c-slide__icon' },
								(0, _preact.h)(_icon2.default, {
									icon: 'magnifying-glass',
									width: '26',
									height: '24',
									title: loweL18n.viewLargerVersion
								})
							)
						),
						(0, _preact.h)(
							'a',
							{ href: link, 'class': 'c-slide__icon' },
							(0, _preact.h)(_icon2.default, {
								icon: 'cart',
								width: '26',
								height: '24',
								title: loweL18n.viewLinkTitle
							})
						)
					),
					(0, _preact.h)(
						'div',
						{ 'class': 'c-slide__excerpt' },
						excerpt
					)
				)
			)
		);
	};

	return SliderSlide;
}(_preact.Component);

exports.default = SliderSlide;

/***/ }),

/***/ "FKwn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__("c/Tr");

var _from2 = _interopRequireDefault(_from);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Provides for handling whether an element is within the viewport. Also
 * lazy-loads a child images with `lazy-src` attribute.
 *
 * @summary In-viewport loading.
 */

/**
 * Transitioning state manager for InView.
 *
 * @class TransitionManager
 */
var TransitionManager = function () {

	/**
  * Creates an instance of TransitionManager.
  *
  * @param {HTMLElement} element The main transitioning element to watch for
  *                              transitioning on.
  */
	function TransitionManager(element) {
		(0, _classCallCheck3.default)(this, TransitionManager);

		this.element = element;

		this._end = this._end.bind(this);
		element.addEventListener('transitionend', this._end);
	}

	/**
  * Return the name of CSS Custom property for the delay value.
  *
  * This a pseudo class constant.
  *
  * @returns {string} The name of CSS Custom property for the delay value,
  *                   including the -- prefix.
  */


	/**
  * @summary Marks the end of the element's transition.
  */
	TransitionManager.prototype._end = function _end() {
		this.element.style.removeProperty(this.CSS_PROPERTY_NAME);
		this.element.removeEventListener('transitionend', this._end);
	};

	/**
  * @summary Marks element as loading (transitioning) in.
  *
  * @param {number} [index=0] The index of the element in the loading
  *                           sequence for staggering effects.
  */


	TransitionManager.prototype.load = function load() {
		var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

		this.element.style.setProperty(this.CSS_PROPERTY_NAME, index * 100 + 'ms');
	};

	(0, _createClass3.default)(TransitionManager, [{
		key: 'CSS_PROPERTY_NAME',
		get: function get() {
			return '--inview-delay';
		}
	}]);
	return TransitionManager;
}();

var _class = function () {

	/**
  * Constructor.
  *
  * @param {HTMLElement[]} elements The elements to manage.
  * @param {number} [threshold=0.2] A number between 0 and 1 as fraction of
  *                                 the element's bounding box that should be
  *                                 visible before it is considered in the
  *                                 viewport.
  */
	function _class(elements) {
		var _this = this;

		var threshold = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.2;
		(0, _classCallCheck3.default)(this, _class);

		this.threshold = threshold;

		var observer = window.IntersectionObserver ? new IntersectionObserver(this._onIntersect.bind(this), { threshold: threshold }) : false;

		elements.forEach(function (element, index) {
			element.className += ' ' + _this.constructor.OUTSIDE_VIEWPORT_CLASSNAME;

			element.transitionManager = new TransitionManager(element);

			element._images = (0, _from2.default)(element.querySelectorAll('img[lazy-src]'));
			if (element._images.length) {
				element._images.forEach(function (image) {
					image.classList.add(_this.constructor.IMAGE_UNLOADED_CLASSNAME);
				});
			}

			if (observer) {
				observer.observe(element);
			} else {
				_this.load(element, index);
			}
		});
	}

	/**
  * @summary Not in-view CSS class name.
  *
  * Gets the CSS state class for a element that is not in-view.
  *
  * @returns {string} The CSS state class for a element that is not in-view.
  */


	/**
  * @summary Manages an intersection change.
  *
  * @param {IntersectionObserverEntry[]} entries List of intersection entries.
  * @param {IntersectionObserver} observer The observer managing the change.
  */
	_class.prototype._onIntersect = function _onIntersect(entries, observer) {
		var _this2 = this;

		entries.filter(function (entry) {
			return entry.isIntersecting || entry.intersectionRatio > _this2.threshold;
		}).forEach(function (entry, i) {
			_this2.load(entry.target, i);

			observer.unobserve(entry.target);
		});
	};

	/**
  * @summary Marks an element as in the viewport.
  *
  * @param {HTMLElement} element The element.
  * @param {HTMLImageElement} element._image Optional. The element's
  *                                          associated image (if it has one).
  * @param {number} index The index of the current element in the loaded
  *                       selection, for staggered transition effects.
  */


	_class.prototype.load = function load(element, index) {
		var _this3 = this;

		requestAnimationFrame(function () {

			// Add delays for staggering
			element.transitionManager.load(index);

			element.classList.remove(_this3.constructor.OUTSIDE_VIEWPORT_CLASSNAME);
		});

		if (element._images.length) {
			element._images.forEach(this._loadImage, this);
		}
	};

	/**
  * @summary Loads element's image.
  *
  * Prefix `src` and `srcset` attributes of the image with `lazy-` to have
  * the image available to be be lazy loaded.
  *
  * @param {HTMLImageElement} image The image element to load.
  */


	_class.prototype._loadImage = function _loadImage(image) {
		var _this4 = this;

		// Remove image unloaded class when image is loaded
		image.addEventListener('load', function () {
			image.classList.remove(_this4.constructor.IMAGE_UNLOADED_CLASSNAME);
		});

		// Copy `lazy-` prefixed attributes without the suffix to load the image.
		(0, _from2.default)(image.attributes).filter(function (attribute) {
			return attribute.name.indexOf('lazy-') === 0;
		}).forEach(function (attribute) {
			image.setAttribute(attribute.name.replace(/^lazy-/, ''), attribute.value);
		});
	};

	(0, _createClass3.default)(_class, null, [{
		key: 'OUTSIDE_VIEWPORT_CLASSNAME',
		get: function get() {
			return 'is-outside-viewport';
		}

		/**
   * @summary Unloaded image CSS class name.
   *
   * Gets the CSS state class for a element's image that has not been loaded
   * yet.
   *
   * @returns {string} The CSS state class for a element's image that has not
   *                   been loaded yet.
   */

	}, {
		key: 'IMAGE_UNLOADED_CLASSNAME',
		get: function get() {
			return 'is-image-unloaded';
		}
	}]);
	return _class;
}();

exports.default = _class;

/***/ }),

/***/ "WSLe":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _preact = __webpack_require__("rMlB");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @summary Slider button navigation preact component.
 *
 * @class
 * @extends {Component}
 */
var SliderMainButton = function (_Component) {
	(0, _inherits3.default)(SliderMainButton, _Component);

	function SliderMainButton(props) {
		(0, _classCallCheck3.default)(this, SliderMainButton);

		var _this = (0, _possibleConstructorReturn3.default)(this, _Component.call(this, props));

		_this.handleClick = _this.handleClick.bind(_this);
		return _this;
	}

	/**
  * @summary Handles a click on this component.
  *
  * @listens document:click
  *
  * @param {MouseEvent} event The click event.
  */


	SliderMainButton.prototype.handleClick = function handleClick(event) {
		event.preventDefault();

		if (typeof this.props.handleClick === 'function') {
			this.props.handleClick(this.props.direction);
		}
	};

	SliderMainButton.prototype.render = function render(_ref) {
		var direction = _ref.direction;

		var classes = 'c-slider__arrow c-slider__arrow--' + direction;

		return (0, _preact.h)('button', { 'class': classes, onClick: this.handleClick });
	};

	return SliderMainButton;
}(_preact.Component); /**
                       * @summary Contains the slider main area button navigation preact component.
                       */

exports.default = SliderMainButton;
;

/***/ }),

/***/ "aR3g":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__("c/Tr");

var _from2 = _interopRequireDefault(_from);

var _preact = __webpack_require__("rMlB");

var _Slider = __webpack_require__("6LoX");

var _Slider2 = _interopRequireDefault(_Slider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @summary Adds slider functionality to featured products slider.
 */

/* globals featuredProductsData: true */

exports.default = function (root) {

	// Current DOM children
	var children = (0, _from2.default)(root.children);

	(0, _preact.render)((0, _preact.h)(_Slider2.default, { data: featuredProductsData }), root);

	// Remove all other DOM children
	children.forEach(function (element) {
		return root.removeChild(element);
	});
};

/***/ }),

/***/ "aW1n":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = SliderMain;

var _preact = __webpack_require__("rMlB");

var _SliderSlide = __webpack_require__("DJyI");

var _SliderSlide2 = _interopRequireDefault(_SliderSlide);

var _SliderMainButton = __webpack_require__("WSLe");

var _SliderMainButton2 = _interopRequireDefault(_SliderMainButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @summary Slider preact preact component.
 *
 * @param {Object} props Props passed to this component.
 * @param {Array} props.data List of slides.
 * @param {number} props.activeIndex The currently active item.
 * @param {function} props.setRef Function to reference to the main DOM element.
 * @param {function} props.handleButtonClick Event listener for click events on
 *                                           the navigation buttons.
 * @returns {JSX} The react component.
 */
function SliderMain(_ref) {
	var data = _ref.data,
	    activeIndex = _ref.activeIndex,
	    setRef = _ref.setRef,
	    handleButtonClick = _ref.handleButtonClick;

	var slides = data.map(function (item) {
		return (0, _preact.h)(_SliderSlide2.default, (0, _extends3.default)({ key: item.index }, item, { state: item.index - activeIndex }));
	});

	return (0, _preact.h)(
		'div',
		{ 'class': 'c-slider__main', ref: setRef, tabIndex: '-1' },
		slides,
		(0, _preact.h)(
			'nav',
			null,
			(0, _preact.h)(
				'ul',
				{ 'class': 'c-slider__navigation' },
				(0, _preact.h)(
					'li',
					{ 'class': 'c-slider__navigation-leaf' },
					(0, _preact.h)(_SliderMainButton2.default, { direction: 'left', handleClick: handleButtonClick })
				),
				(0, _preact.h)(
					'li',
					{ 'class': 'c-slider__navigation-leaf' },
					(0, _preact.h)(_SliderMainButton2.default, { direction: 'right', handleClick: handleButtonClick })
				)
			)
		)
	);
} /**
   * @summary Contains the slider main area preact component.
   */

;

/***/ }),

/***/ "erO0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__("woOf");

var _assign2 = _interopRequireDefault(_assign);

exports.default = Icon;

var _preact = __webpack_require__("rMlB");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Icon(props) {
	var icon = props.icon;

	var attributes = (0, _assign2.default)({}, props);
	delete attributes.icon;

	return (0, _preact.h)(
		'svg',
		attributes,
		(0, _preact.h)('use', { xlinkHref: wp_data.iconSheet + '#' + icon })
	);
} /**
   * @summary Icon preact component
   */

;

/***/ }),

/***/ "mClu":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("kM2E");
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__("+E39"), 'Object', { defineProperty: __webpack_require__("evD5").f });


/***/ }),

/***/ "tA1e":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _preact = __webpack_require__("rMlB");

var _SliderThumbsThumb = __webpack_require__("4k8/");

var _SliderThumbsThumb2 = _interopRequireDefault(_SliderThumbsThumb);

var _inView = __webpack_require__("FKwn");

var _inView2 = _interopRequireDefault(_inView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @summary Slider thumbnails list preact component.
 */
var SliderThumbs = function (_Component) {
	(0, _inherits3.default)(SliderThumbs, _Component);

	function SliderThumbs(props) {
		(0, _classCallCheck3.default)(this, SliderThumbs);

		var _this = (0, _possibleConstructorReturn3.default)(this, _Component.call(this, props));

		_this.setThumb = _this.setThumb.bind(_this);

		_this.thumbElements = [];
		return _this;
	}

	/**
  * @summary Sets reference to a thumbnail DOM element.
  *
  * @param {HTMLElement} element The DOM element.
  * @param {number} index The index key of the thumbnail.
  */


	SliderThumbs.prototype.setThumb = function setThumb(element, index) {
		this.thumbElements[index] = element;
	};

	SliderThumbs.prototype.componentDidMount = function componentDidMount() {
		new _inView2.default(this.thumbElements, 0.2, this.inviewLoad);
	};

	SliderThumbs.prototype.render = function render(_ref) {
		var _this2 = this;

		var data = _ref.data,
		    activeIndex = _ref.activeIndex,
		    handleClick = _ref.handleClick;

		var thumbs = data.map(function (item) {
			return (0, _preact.h)(_SliderThumbsThumb2.default, (0, _extends3.default)({
				key: item.index
			}, item, {
				active: activeIndex === item.index,
				handleClick: handleClick,
				onRef: _this2.setThumb
			}));
		});

		return (0, _preact.h)(
			'ul',
			{ 'class': 'l-grid l-grid--300 l-grid--rigid l-grid--products' },
			thumbs
		);
	};

	return SliderThumbs;
}(_preact.Component); /**
                       * @summary Contains the slider thumbnails list preact component.
                       */

exports.default = SliderThumbs;
;

/***/ }),

/***/ "tSfd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
/**
 * @summary Utility to decode escaped HTML entities within a string.
 */

var slave = document.createElement('textarea');

/**
 * @summary Decodes entities within a string.
 *
 * @param {string} string The string to decode.
 * @return {string} The decoded string.
 */

exports.default = function (string) {
  slave.innerHTML = string;
  return slave.value;
};

/***/ }),

/***/ "wxAW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__("C4MV");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ })

});


// WEBPACK FOOTER //
// a725c029b41f5ab52aba.js